import axiosAuth from '../../axiosMain';

async function index(user_id) {
  let response = await axiosAuth.get('/notifications/settings/' + user_id);
  return response.data;
}
async function update(data, user_id) {
  let response = await axiosAuth.post('/notifications/settings/' + user_id, data);
  return response.data;
}

export default {
  index,
  update,
};
